import * as React from "react"
import { connect } from "react-redux";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import { AppPageWrapper } from "../NavMenu/AppPageWrapper";
import { Button, Col, Form, InputGroup, Modal, ModalBody, Spinner } from "react-bootstrap";
import { FaAngleDown, FaSearch } from "react-icons/fa";
import 'react-datepicker/dist/react-datepicker.css'
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { Subscription } from "rxjs";
import ActionButton from "../ActionButton";
import TextFormControl from "../OrderRequests/TextFormControl";
import { DonorIdRegexp, InvalidDonorId, MaxDonorIdLength } from "../../config/Constants";
import { SearchDonorGetObservable } from "../../api/OrderRequests/SearchDonorGet";
import { BirthdayInput } from "../FormattedInputs/BirthdayInput";
import { GovReportsObservable } from "../../api/GovReports/GovReportsObservable";
import CompanyInput from "../FormattedInputs/CompanyInput";
import AutoFilterCompany from "../../api/Companies/CompanyModel/AutoFilterCompany";
import { AppState } from "../../AppState";
import { isCompanyAdmin, isLocationAdmin, isPortalAdmin } from "../../authentication/isAdminRole";
import GovPoolGet from "../../api/Randoms/GovPoolGet";
import GovPoolData from "../../api/Randoms/RandomsModel/GovPoolData";
import FormatError from "../../formatters/FormatError";
import { GetSelectedAssignedClinic } from "../../authentication/SelectedCompany/CompanySelectionDrivenSelectors";
import { Donor } from "../../api/OrderRequests/OrderRequestsModel/Donor";
import { RegulatoryModeObservable } from "../../api/OrderRequests/OrderRequestsConstraintGet";
import { GetRegulatoryModeDonor } from "../OrderRequests/OrderModels";
import { RouteComponentProps } from "react-router";
import { Home } from "../../config/Routes";
import getOnTrackReport, { OnTrackReportRecord, Report } from "../../api/GovReports/OnTrackReport";
import { IsOnTrack } from "../../App";
import { LogOut } from "../../AppStore";
import FormatDate from "../../formatters/FormatDate";
import AutoFilterLocation from '../../api/Location/LocationModel/AutoFilterLocation';
import AutoFilterRegion from '../../api/Regions/Model/AutoFilterRegion';
import AutoFilterLocationsGet from '../../api/Location/AutoFilterLocationsGet';

interface ReportParametersProps {
  isLocationAdmin?: boolean
  isCompanyAdmin?: boolean
  isPortalAdmin?: boolean
  company?: number
}

interface ReportParametersState {
  report: OnTrackReportRecord
  from?: Date
  to?: Date
  donorId?: string
  donor?: Donor
  companies: AutoFilterCompany[]
  locations: AutoFilterLocation[]
  idType?: GetRegulatoryModeDonor
  selectedCompany?: AutoFilterCompany
  selectedLocation?: AutoFilterLocation
  locationsLoading: boolean
  groups: GovPoolData[]
  selectedGroup?: GovPoolData
  groupLoading: boolean
  donorLoading: boolean
  regulatoryModeLoading: boolean
  companyChecked: boolean
  groupChecked: boolean
  donorChecked: boolean
  loading?: boolean
}

class ReportParameters extends React.PureComponent<ReportParametersProps & RouteComponentProps, ReportParametersState> {
  state: ReportParametersState = {
    report: getOnTrackReport(this.props.location.pathname as Report),
    companies: [],
    locations: [],
    groups: [],
    locationsLoading: false,
    groupLoading: false,
    donorLoading: false,
    regulatoryModeLoading: false,
    companyChecked: true,
    groupChecked: false,
    donorChecked: false
  }

  typeaheadGroup = React.createRef<AsyncTypeahead<GovPoolData>>()

  subscriptions = new Subscription()
  printSubscription?: Subscription
  donorSubscription?: Subscription

  handleCompanyChange = (companies: AutoFilterCompany[]) => {
    this.setState({ companies: companies, selectedCompany: companies[0] })
    this.loadAllLocations(companies[0])
  }
  handleLocationChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    let location = this.state.locations.find(l => l.AccountID === Number(event.target.value))
    this.setState({ selectedLocation: location })
  }
  handleGroupChange = (selected: GovPoolData) => this.setState({ selectedGroup: selected })
  handleDonorIdChange = (value: string) => this.setState({ donorId: value })

  handleCompanyChecked = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ companyChecked: e.target.checked, selectedCompany: this.state.companies[0], groupChecked: false, donorChecked: false, selectedGroup: undefined, donorId: undefined, donor: undefined  })
  }

  handleGroupChecked = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ companyChecked: false, groupChecked: e.target.checked, donorChecked: false, selectedCompany: undefined, donorId: undefined, donor: undefined })
  }

  handleDonorChecked = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ companyChecked: false, groupChecked: false, donorChecked: e.target.checked, selectedGroup: undefined, selectedCompany: undefined })
  }

  handleGenerateReportClick = () => {
    this.setState({ loading: true })
    this.printSubscription && this.printSubscription.unsubscribe()
    let accountID = this.state.selectedLocation?.AccountID || this.state.selectedCompany?.AccountID
    this.printSubscription = GovReportsObservable({
      reportType: this.state.report.type,
      fromDate: FormatDate(this.state.from),
      toDate: FormatDate(this.state.to),
      accountID: this.state.companyChecked ? accountID : undefined,
      groupID: this.state.groupChecked ? this.state.selectedGroup?.GovPoolId : undefined,
      personID: this.state.donorChecked ? this.state.donor?.PersonID : undefined
    }).subscribe(
      data => {
        this.setState({ loading: false })
        this.print(data)
      },
      error => {
        this.setState({ loading: false })
        toast.error(FormatError(error))
      }
    )
  }

  handleCancelClick = () => (this.props as RouteComponentProps).history?.push(Home)

  print(base64pdf: string) {
    const pdfWindow = window.open('about:blank')
    if (pdfWindow) {
      pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(base64pdf) + "'></iframe>")
    }
  }

  validateDonorFormat = () => {
    const donorId = this.state.donorId || ""
    return !this.state.donorChecked || (donorId.length > 0 && donorId.length <= MaxDonorIdLength && DonorIdRegexp.test(donorId))
  }

  isParamsValid = () => {
    const { selectedCompany, selectedGroup, donor, companyChecked, groupChecked, donorChecked, from, to } = this.state
    return from && to && ((companyChecked && selectedCompany) || (groupChecked && selectedGroup) || (donorChecked && donor))
  }

  onDonorSearch = () => {
    this.donorSubscription && this.donorSubscription.unsubscribe()
    this.donorSubscription = SearchDonorGetObservable({
      CompanyID: this.props.company || 0,
      Identifier: this.state.donorId,
      IdentifierType: this.state.idType?.Rank,
      RegulatoryModeID: 0,
      isPortalAdmin: this.props.isPortalAdmin
    }).subscribe(
    (result: Donor[]) => {
      this.setState({ donorLoading: false, donor: result[0] })
      !result.length && toast.error("Donor was not found.")
    },
    (error) => {
      this.setState({ donorLoading: false })
      toast.error(FormatError(error))
    })
  }

  componentDidUpdate(prevProps: ReportParametersProps & RouteComponentProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setState(prev => ({
        ...prev,
        report: getOnTrackReport(this.props.location.pathname as Report),
        selectedCompany: this.props.isPortalAdmin ? undefined : prev.selectedCompany,
        selectedGroup: undefined,
        donorId: undefined,
        donor: undefined
      }))
    }
  }

  componentDidMount() {
    if(!IsOnTrack()) {
      toast.error("The request is unauthorized.")
      LogOut()
    }
    this.setState({ groupLoading: true, regulatoryModeLoading: true })

    this.subscriptions.add(
      RegulatoryModeObservable(0).subscribe(
        results => this.setState({ idType: results.find(item => item.PrimaryIDType === "EmployerID"), regulatoryModeLoading: false }),
        error => {
          this.setState({ regulatoryModeLoading: false })
          toast.error(error)
        }
      )
    )

    this.subscriptions.add(
      GovPoolGet().subscribe(
        (results: GovPoolData[]) => this.setState({ groups: results, groupLoading: false }),
        (error) => {
          this.setState({ groupLoading: false })
          toast.error(FormatError(error))
        }
      )
    )
  }

  componentWillUnmount() {
    this.subscriptions && this.subscriptions.unsubscribe()
    this.donorSubscription && this.donorSubscription.unsubscribe()
    this.printSubscription && this.printSubscription.unsubscribe()
  }

  loadAllLocations = (company?: AutoFilterCompany, region?: AutoFilterRegion) => {
    this.setState({ locationsLoading: true })
    this.subscriptions.add(
      AutoFilterLocationsGet(company?.AccountID || 0, region?.Code || "", "").subscribe(
      data =>
        {
          let location = undefined
          if (this.props.isLocationAdmin)
          {
            location = data[0]
          }
          this.setState({ locations: data, locationsLoading: false, selectedLocation: location })
        },
   () => this.setState({ locationsLoading: false })
      )
    )
  }

  render() {
    const { report, donorId, donor, donorLoading, companyChecked, groupChecked, donorChecked, from, to } = this.state

    return (<AppPageWrapper parentClassName={"align-items-center"} showNav>
      <Modal.Dialog size="lg">
        <Modal.Header>
          <Modal.Title className="text-uppercase">Report Parameters for {report.title}</Modal.Title>
        </Modal.Header>
        <ModalBody>
          <Form>
            <Form.Row className="form-group">
              <Form.Label column lg={2} htmlFor="dateCollected">Date Collected</Form.Label>
              <Form.Label column lg={1} htmlFor="from" className="required">From</Form.Label>
              <Col lg={4}>
                <DatePicker id="from"
                  className="form-control"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  enableTabLoop={false}
                  selected={from}
                  maxDate={to || new Date()}
                  onChange={date => this.setState({ from: date as Date })}
                  customInput={<BirthdayInput />}
                />
              </Col>
              <Form.Label column lg={1} htmlFor="to" className="required">To</Form.Label>
              <Col lg={4}>
                <DatePicker id="to"
                  className="form-control"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  enableTabLoop={false}
                  selected={to}
                  minDate={from}
                  maxDate={new Date()}
                  onChange={date => this.setState({ to: date as Date })}
                  customInput={<BirthdayInput />}
                />
              </Col>
            </Form.Row>
            <Form.Row className="form-group">
              <Form.Label column lg={12}>Filter by:</Form.Label>
            </Form.Row>
            <Form.Row className="form-group">
              <Col md={1}>
                <Form.Check id="filter-by-company" name="filter-by"
                  type="radio"
                  label=""
                  className="abc-radio mx-2"
                  inline
                  checked={companyChecked} onChange={(e) => this.handleCompanyChecked(e)}
                />
              </Col>
              <Form.Label column lg={2} htmlFor="filter-by-company">Company</Form.Label>
              <Col lg={9}>
                <CompanyInput disabled={!companyChecked} onChange={this.handleCompanyChange} />
              </Col>
            </Form.Row>
            <Form.Row className="form-group">
              <Col md={1}>
                <div className="abc-radio mx-2 form-check form-check-inline">&nbsp;</div>
              </Col>
              <Form.Label column lg={2} htmlFor="filter-by-company">Location</Form.Label>
              <Col lg={9}>
                <Form.Control id="location" as="select" value={this.state.selectedLocation?.AccountID} onChange={this.handleLocationChange} disabled={!companyChecked}>
                  {!this.props.isLocationAdmin && <option value="">Select</option>}
                  {this.state.locations.map(l => <option value={l.AccountID} key={l.AccountID}>{l.Name}</option>)}
                </Form.Control>
              </Col>
            </Form.Row>
            <Form.Row className="form-group">
              <Col md={1}>
                <Form.Check id="filter-by-group" name="filter-by"
                  type="radio"
                  label=""
                  className="abc-radio mx-2"
                  inline
                  checked={groupChecked} onChange={(e) => this.handleGroupChecked(e)}
                />
              </Col>
              <Form.Label column lg={2} htmlFor="filter-by-group">Group</Form.Label>
              <Col lg={9}>
                <AsyncTypeahead id="group-select"
                  emptyLabel="No Groups Found"
                  ref={this.typeaheadGroup}
                  filterBy={() => true}
                  isLoading={this.state.groupLoading}
                  onChange={items => this.handleGroupChange(items[0])}
                  onSearch={() => { }}
                  options={this.state.groups}
                  selected={this.state.selectedGroup ? [this.state.selectedGroup] : []}
                  minLength={0}
                  labelKey="Name"
                  disabled={!groupChecked}
                  placeholder="Enter the Group name"
                  inputProps={{ autoComplete: "chrome-off" }}>
                  {!this.state.groupLoading && groupChecked &&
                    <Button variant="toggle" onClick={() => this.typeaheadGroup.current?.toggleMenu()}>
                      <FaAngleDown />
                    </Button>}
                </AsyncTypeahead>
              </Col>
            </Form.Row>
            <Form.Row>
              <Col md={1}>
                <Form.Check id="filter-by-donor" name="filter-by"
                  type="radio"
                  label=""
                  className="abc-radio mx-2"
                  inline
                  checked={donorChecked} onChange={(e) => this.handleDonorChecked(e)}
                />
              </Col>
              <Form.Label column lg={2} htmlFor="filter-by-donor">Donor ID</Form.Label>
              <Col lg={5}>
                <InputGroup className="mb-3">
                  <TextFormControl value={donorId}
                    disabled={!donorChecked}
                    maxLength={MaxDonorIdLength}
                    changeHandler={(value) => this.handleDonorIdChange(value)}
                    isValid={() => this.validateDonorFormat()}
                    enterTapHandler={this.onDonorSearch} />
                  <Form.Control.Feedback className="order-last" type="invalid">{InvalidDonorId}</Form.Control.Feedback>
                  <InputGroup.Append>
                    <Button className="btn-rounded-right" onClick={() => this.onDonorSearch()} disabled={!donorId}>
                      {this.state.donorLoading ? <Spinner size="sm" animation="border" /> : <FaSearch />}
                    </Button>
                  </InputGroup.Append>
                </InputGroup>
                {!donorLoading && donor && <Form.Text muted>Donor: {donor.FirstName} {donor.LastName} was found.</Form.Text>}
              </Col>
            </Form.Row>
          </Form>
        </ModalBody>
        <Modal.Footer className="justify-content-between">
          <Button variant="secondary" onClick={() => this.handleCancelClick()}>Cancel</Button>
          <ActionButton variant="primary" disabled={!this.isParamsValid()} onClick={() => this.handleGenerateReportClick()} spin={this.state.loading} disableOnSpin>Continue</ActionButton>
        </Modal.Footer>
      </Modal.Dialog>
    </AppPageWrapper>)
  }
}

function mapStateToProps(state: AppState): ReportParametersProps {
  return {
    isLocationAdmin: isLocationAdmin(state),
    isCompanyAdmin: isCompanyAdmin(state),
    isPortalAdmin: isPortalAdmin(state),
    company: GetSelectedAssignedClinic(state)?.AccountID
  }
}

const ConnectedReportParameters = connect(mapStateToProps, null)(ReportParameters)
export default ConnectedReportParameters
